import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { HasUnsavedDataGuard } from "src/app/hasunsaveddata.guard";
import { EditVideoForMeComponent } from "./components/edit-video-for-me/edit-video-for-me.component";
import { Personalizationcomponent } from "./components/Personalization/Personolization.component";
import { PersonalizeCardComponent } from "./components/personalize-card/personalize-card.component";
import { VideoEditorComponent } from "src/app/shared/components/video-editor/video-editor.component";
import { CardEditorComponent } from "src/app/shared/components/card-editor/card-editor.component";

const routes: Routes = [
    { path: ':videoDesc/video/:data', component: Personalizationcomponent, canDeactivate: [HasUnsavedDataGuard] },
    { path: ':videoDesc/videoforme/:data', component: EditVideoForMeComponent, canDeactivate: [HasUnsavedDataGuard] },
    { path: ':videoDesc/uservideo/:data', component: Personalizationcomponent, canDeactivate: [HasUnsavedDataGuard] },
    { path: ':videoDesc/video-editor/:data', component: VideoEditorComponent, canDeactivate: [HasUnsavedDataGuard] },
    { path: ':cardDesc/card/:data', component: PersonalizeCardComponent },
    { path: ':cardDesc/card-editor/:data', component: CardEditorComponent },
    { path: ':cardDesc/usercard/:data', component: PersonalizeCardComponent },
]

@NgModule({
    declarations: [],
    imports: [
        RouterModule.forChild(routes)
    ],
    exports: [RouterModule]
})
export class PersonaliseRouting { }
